import type { FCState } from '../types';

export const initialState: FCState = {
  data: {
    Name: undefined,
    ResidencyStatus: undefined,
  },
  mcaf: {
    CpfNumber: undefined,
    DateOfBirth: undefined,
    FinOrPassport: undefined,
    IsCpfSameAsNric: true,
    Name: undefined,
    ResidencyStatus: undefined,
    StartDate: undefined,
  },
};
